import { CircularProgress } from "@mui/material";
import { Card } from "react-bootstrap";
import CountingEffect from "../project-dashboard/test-case/dashboard/metrics/CountingEffect";

export const CustomXAxisTick = ({ x, y, payload, projectsMap }) => {
  const projectName = projectsMap[payload.value] || payload.value;
  return (
    <g transform={`translate(${x},${y})`}>
      <title>{projectName}</title>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="middle"
        fill="#666"
        style={{ fontSize: 12 }}>
        {payload.value}
      </text>
    </g>
  );
};

export const CustomStatCard = ({ title, count, isLoading }) => (
  <Card className="shadow-sm" style={{ minHeight: 100, fontSize: '3rem' }}>
    <Card.Body className="d-flex flex-column align-items-center justify-content-center">
      <Card.Title
        as="h6"
        className="text-center fw-semibold"
        style={{ fontSize: '1rem' }}>
        {title}
      </Card.Title>
      <Card.Text
        as="div"
        className="d-flex justify-content-center align-items-center mt-auto">
        {isLoading ? (
          <div className="mb-2">
            <CircularProgress sx={{ color: 'orange' }} />
          </div>
        ) : (
          <CountingEffect start={0} end={count || 0} duration={1000} />
        )}
      </Card.Text>
    </Card.Body>
  </Card>
);